import { createApp } from "vue";
import { i18n } from "./../i18n";
import Toast from "vue-toastification";
import toastConfig from "./../toast";
import store from "./../client/store";

import "./../vee-validate";

const app = createApp();

app.use(store);
app.use(i18n);
app.use(Toast, toastConfig);

// partials
app.component(
  "services",
  require("./../client/views/home/Services.vue").default
);
app.component("reviews", require("./../client/views/home/Reviews.vue").default);
app.component(
  "discount-popup",
  require("./../client/views/partials/DiscountPopup.vue").default
);

app.mount("#app");
